
import React from "react";
import { useTheme } from "@/lib/theme/ThemeContext";

export function ChildrenLoadingState() {
  const isLightTheme = false;

  return (
    <div className="flex justify-center items-center h-64">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          {/* Outer ring */}
          <div className={`w-12 h-12 border-4 rounded-full ${isLightTheme ? "border-[#308CFD]/20" : "border-purple-600/20"}`}></div>
          {/* Inner spinning ring */}
          <div className={`absolute inset-0 w-12 h-12 border-4 border-t-transparent rounded-full animate-spin ${isLightTheme ? "border-[#308CFD]" : "border-purple-600"}`}></div>
        </div>
        <p className={`text-sm ${isLightTheme ? "text-slate-500" : "text-gray-400"}`}>Loading children...</p>
      </div>
    </div>
  );
}
